export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <div
      className="animate-spin rounded-full border-2 border-slate-300 border-t-brand-500 dark:border-slate-700 dark:border-t-brand-400"
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}
